import * as React from "react";

function Close(props) {
  return (
    <svg width={45} height={45} fill="none" {...props}>
      <path fill="url(#prefix__pattern0_6018_18)" d="M0 0h45v45H0z" />
      <defs>
        <pattern
          id="prefix__pattern0_6018_18"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#prefix__image0_6018_18" transform="scale(.01)" />
        </pattern>
        <image
          id="prefix__image0_6018_18"
          width={100}
          height={100}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADF0lEQVR4nO3dzWoUQRQF4JvEVI1WooREg8/RdN1bcUKWbsTdLERF30kQXKmIa0EEA3Hj7wuI4HPoYHSTkRqiCaJxfrozp5LzQW9DVZ2+1V2TmhoRIiIiIiIiIiIiIiIiIiI6dWI8L2Wak253RU6CjtkVn+Jzn7Tvkw580h/O9HXH6jsiMi+45r3qXZfiW2/x+37b+970WWcjbkpxer0Fl+L9/Y789crBLFXVmoBZqqq1YRBHtT3pvdxHKYUzfXBUhw5dn4LquoAIquu5TaO03aX4UErQSWnDJ90bMRCYUMIYYRxc9VVB501fjNep2YcSJgpDB7mvAm7u0AO8iFDCpGEMA4lfhm9hsLa2zow5Xf15x30+t1ldPq7mhpQuedOPE7c36R7426LIFBUyOM5KmaoyDirkq6BzKe5MGcig7UppoDKGl0vxpaBbNLs5dSCpvUpppDL2r8UUb0ghi8J3iKGEBsNwpm/gnx+/LHW7F5vquG8olCbDyH8n91FK0tQ87Rt4piC1ZaYQBiIAtAHKLAckMAycgQkMA2eAAsMYzXEMVGAY42lzwALDmEwbAxcYBtZCzYMtRIvU6F2d2n9ZOBVgQjGGgROKMQycSjGGgTN9GcPAeaYYw8B50BvDwAnFGAZOKMYwphIYCI7AKQtH4EMdR+BrL47AhSEOfnQChB8uApl5GIlrFLwwEkPhv3CRcJMDEG4DAsKNckC4lRQIN1sD4dcRgCBs7wwAbYCANBABqC0zsVzXq2h7bUPDe4lzH6UI+WvRptuId2NosFKc6at8lIigyyexIYbRRiidFG8LOmf6AWWaanv6chbfC7h5b3EXsTLaqZT4Dfs0h253Bbky2qgUqaoLciKPZ5rR62SYplKKOJ5psjesIo/4c6bbgs6pXi8pjGlCcam+JiVwSR8hT1MNTV9PpRhmZ53FJ0ffXXEHcbW7XNer/zsVzyV9nPsopcnTVz4G7/eD3uJuPtyss6G3oE+G7vUW8qIvrzMOvcb3c1+KmaZGPIwf+EjVf5or+IcEiIiIiIiIiIiIiIiIiIhIJvYTlKsEChroFHQAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
}

export default Close;
